import React, { Component } from "react";
import { Popover, PopoverBody } from "../libraries/reactstrap";
import axios from "axios";

import { BACKEND_CONFIG } from "../config/consts";
import { QuoteSpinnerConsumer } from "../context/quote-spinner-context";
import headerImg from "../images/communication.svg";

import CommunicationsCard from "./CommunicationsCard";

class CommunicationsPanel extends Component {
  constructor() {
    super();

    this.toggle = this.toggle.bind(this);
    this.toggleSort = this.toggleSort.bind(this);
    this.makeApiCall = this.makeApiCall.bind(this);

    this.state = {
      newest: true,
      popoverOpen: false,
      filter: {
        days30: false,
        days60: true,
        days90: false,
        year: false,
        allDates: false,
        documents: true,
        certificates: true,
        endorsements: true,
        bindRequests: true,
        otherService: true,
        policyCancel: true,
        policyEvents: true,
      },
      oldFilterState: {},
    };
  }

  toggleSort(newState) {
    this.setState({
      newest: newState,
    });
  }

  sortCards(data, newest) {
    data.sort(function (a, b) {
      return newest
        ? new Date(b.Date) - new Date(a.Date)
        : new Date(a.Date) - new Date(b.Date);
    });

    return data;
  }

  toggle() {
    if (!this.state.popoverOpen) {
      this.setState({ oldFilterState: { ...this.state.filter } });
    } else if (
      JSON.stringify(this.state.oldFilterState) !==
      JSON.stringify(this.state.filter)
    ) {
      this.makeApiCall();
    }

    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  }

  toggleFiler(newFilter) {
    var result = Object.assign(this.state.filter, newFilter);

    this.setState({ filter: result });
    this.makeApiCall();
  }

  makeApiCall() {
    let path = window.location.href.split("/");
    let days = this.state.filter.days30
      ? "30"
      : this.state.filter.days60
      ? "60"
      : this.state.filter.days90
      ? "90"
      : this.state.filter.year
      ? "365"
      : "";
    let activityTypes =
      (this.state.filter.documents ? "&activityType=document" : "") +
      (this.state.filter.certificates ? "&activityType=certificates" : "") +
      (this.state.filter.endorsements ? "&activityType=endorsements" : "") +
      (this.state.filter.otherService
        ? "&activityType=otherservicerequests"
        : "") +
      (this.state.filter.policyEvents ? "&activityType=policyevents" : "") +
      (this.state.filter.bindRequests ? "&activityType=bindrequest" : "") +
      (this.state.filter.policyCancel
        ? "&activityType=policycancellationrequests"
        : "");

    axios({
      url:
        BACKEND_CONFIG.apiUrl +
        "panels/communications/" +
        path[path.length - 1] +
        "?days=" +
        days +
        activityTypes,
    }).then((data) => {
      this.sortCards(data.data.Cards, this.state.newest);
      this.setState({ communicationsData: data.data });
    });
  }

  componentDidMount() {
    this.setUpdateFunc(this.makeApiCall);
    this.makeApiCall();
  }

  render() {
    let sorted = [];

    if (this.state.communicationsData) {
      let temp = this.sortCards(
        this.state.communicationsData.Cards,
        this.state.newest
      );
      for (let i = 0; i < temp.length; i++) {
        sorted.push(<CommunicationsCard key={i} data={temp[i]} />);
      }
    }

    return (
      <div className="four-panel">
        <QuoteSpinnerConsumer>
          {(contextState) => {
            this.setUpdateFunc = contextState.setUpdateFunction;
          }}
        </QuoteSpinnerConsumer>
        <div className="four-panel-main-header">
          <img alt="communications" src={headerImg} />{" "}
          <span className="four-panel-main-header-name">COMMUNICATIONS</span>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a onClick={this.toggle} className="four-panel-main-header-filter">
            <span id="communications-filter">Filter </span>
            <div className="sort-down" />
          </a>
          <Popover
            placement="bottom"
            trigger="legacy"
            fade={false}
            isOpen={this.state.popoverOpen}
            target="communications-filter"
            toggle={this.toggle}
            offset={"[-77, 0]"}
          >
            <PopoverBody className="filter-body">
              <div className="header-block">Date: </div>
              <div>
                30 days
                <input
                  onChange={(e) => {
                    this.toggleFiler({
                      days30: true,
                      days60: false,
                      days90: false,
                      year: false,
                      allDates: false,
                    });
                  }}
                  type="checkbox"
                  checked={this.state.filter.days30}
                />
              </div>
              <div>
                60 days
                <input
                  onChange={(e) => {
                    this.toggleFiler({
                      days30: false,
                      days60: true,
                      days90: false,
                      year: false,
                      allDates: false,
                    });
                  }}
                  type="checkbox"
                  checked={this.state.filter.days60}
                />
              </div>
              <div>
                90 days
                <input
                  onChange={(e) => {
                    this.toggleFiler({
                      days30: false,
                      days60: false,
                      days90: true,
                      year: false,
                      allDates: false,
                    });
                  }}
                  type="checkbox"
                  checked={this.state.filter.days90}
                />
              </div>
              <div>
                1 year
                <input
                  onChange={(e) => {
                    this.toggleFiler({
                      days30: false,
                      days60: false,
                      days90: false,
                      year: true,
                      allDates: false,
                    });
                  }}
                  type="checkbox"
                  checked={this.state.filter.year}
                />
              </div>
              <div>
                All Dates
                <input
                  onChange={(e) => {
                    this.toggleFiler({
                      days30: false,
                      days60: false,
                      days90: false,
                      year: false,
                      allDates: true,
                    });
                  }}
                  type="checkbox"
                  checked={this.state.filter.allDates}
                />
              </div>
              <div className="header-block">
                Activity type:
                {this.state.filter.documents ||
                this.state.filter.certificates ||
                this.state.filter.endorsements ||
                this.state.filter.bindRequests ||
                this.state.filter.otherService ||
                this.state.filter.policyCancel ||
                this.state.filter.policyEvents ||
                this.state.filter.underwriterReferral ||
                this.state.filter.orderMVR ? (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    onClick={(e) => {
                      this.toggleFiler({
                        documents: false,
                        certificates: false,
                        endorsements: false,
                        bindRequests: false,
                        otherService: false,
                        policyCancel: false,
                        policyEvents: false,
                      });
                    }}
                  >
                    Deselect all
                  </a>
                ) : (
                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                  <a
                    onClick={(e) => {
                      this.toggleFiler({
                        documents: true,
                        certificates: true,
                        endorsements: true,
                        bindRequests: true,
                        otherService: true,
                        policyCancel: true,
                        policyEvents: true,
                      });
                    }}
                  >
                    Select all
                  </a>
                )}
              </div>
              <div>
                Documents
                <input
                  type="checkbox"
                  onChange={(e) => {
                    this.toggleFiler({ documents: e.target.checked });
                  }}
                  checked={this.state.filter.documents}
                />
              </div>
              <div>
                Certificates
                <input
                  type="checkbox"
                  onChange={(e) => {
                    this.toggleFiler({ certificates: e.target.checked });
                  }}
                  checked={this.state.filter.certificates}
                />
              </div>
              <div>
                Endorsements
                <input
                  type="checkbox"
                  onChange={(e) => {
                    this.toggleFiler({ endorsements: e.target.checked });
                  }}
                  checked={this.state.filter.endorsements}
                />
              </div>
              <div>
                Bind Requests
                <input
                  type="checkbox"
                  onChange={(e) => {
                    this.toggleFiler({ bindRequests: e.target.checked });
                  }}
                  checked={this.state.filter.bindRequests}
                />
              </div>
              <div>
                Other Service Requests
                <input
                  type="checkbox"
                  onChange={(e) => {
                    this.toggleFiler({ otherService: e.target.checked });
                  }}
                  checked={this.state.filter.otherService}
                />
              </div>
              <div>
                Policy Cancel/ERP Requests
                <input
                  type="checkbox"
                  onChange={(e) => {
                    this.toggleFiler({ policyCancel: e.target.checked });
                  }}
                  checked={this.state.filter.policyCancel}
                />
              </div>
              <div>
                Policy Events
                <input
                  type="checkbox"
                  onChange={(e) => {
                    this.toggleFiler({ policyEvents: e.target.checked });
                  }}
                  checked={this.state.filter.policyEvents}
                />
              </div>
            </PopoverBody>
          </Popover>
        </div>
        <div className={"communications-oldnew-sort"}>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            className={this.state.newest ? "selected" : "unselected"}
            onClick={() => this.toggleSort(true)}
          >
            Newest
          </a>
          <span className={"selected"}> | </span>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a
            onClick={() => this.toggleSort(false)}
            className={!this.state.newest ? "selected" : "unselected"}
          >
            Oldest
          </a>
        </div>
        {this.state.communicationsData && sorted}
      </div>
    );
  }
}

export default CommunicationsPanel;
